/**
 * 칼럼 머리글 값 거르기(레거시 그리드의 머리글 ▾ — 2026-10-02 함남열 「월정기 표도 칼럼마다 골라 보기」).
 *
 * 화면에 **전부 받아 온 목록**에서만 쓴다 — 서버가 쪽 단위로 주는 표에 걸면 「이 쪽 안에서만」 거르게 되고
 * 그 차이가 안 보인다(issues 107). 값은 **화면에 보이는 글자 그대로**로 비교한다(금액은 쉼표 붙은 글자).
 *
 * 순수 함수만 둔다 — 화면(`components/ColumnFilter.tsx`)과 점검 스크립트(`scripts/mo-board-check.mjs`)가 같이 쓴다.
 */

/** 칸 이름 → 고른 값들. 칸이 없으면(undefined) 그 칸은 거르지 않는다. 빈 배열 = 아무것도 안 보임. */
export type ColFilters = Record<string, string[] | undefined>;

/** 빈 칸을 목록에서 고를 수 있게 붙이는 이름. */
export const BLANK = '(빈 값)';

export const cellText = (v: unknown): string =>
  v === null || v === undefined || String(v).trim() === '' ? BLANK : String(v);

export const activeFilterCount = (f: ColFilters): number =>
  Object.values(f).filter((v) => v !== undefined).length;

/** 한 줄이 걸린 칸 전부를 통과하나. `skip` 칸은 안 본다(그 칸의 목록을 만들 때 — 엑셀 거르기와 같다). */
export function passes<T>(row: T, filters: ColFilters, getters: Record<string, (r: T) => string>, skip?: string): boolean {
  for (const [key, sel] of Object.entries(filters)) {
    if (sel === undefined || key === skip) continue;
    const get = getters[key];
    if (!get) continue;
    if (!sel.includes(get(row))) return false;
  }
  return true;
}

/** 칸의 값 목록(건수 포함) — 숫자는 숫자 순, 글자는 가나다 순, 빈 값은 맨 끝. */
export function distinctCounts<T>(rows: T[], get: (r: T) => string): { value: string; count: number }[] {
  const m = new Map<string, number>();
  for (const r of rows) {
    const v = get(r);
    m.set(v, (m.get(v) ?? 0) + 1);
  }
  return [...m.entries()]
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => (a.value === BLANK ? 1 : b.value === BLANK ? -1
      : a.value.localeCompare(b.value, 'ko', { numeric: true })));
}
